import axiosInstance from "./index";

export const getUsers = () => {
  return axiosInstance.get("Users");
};

export const getUser = (userId = "") => {
  return axiosInstance.get(`Users/${userId}`);
};

export const getMyUser = (accessToken = "") => {
  const headers = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axiosInstance.post(`Users/me`, {}, accessToken ? headers : undefined);
};

export const updateUser = (userId = "", body = {}) => {
  return axiosInstance.put(`Users/${userId}`, { ...body });
};

export const getUserRoles = () => {
  return axiosInstance.get("Users/roles");
};

export const getCustomer = (customerId = "") => {
  return axiosInstance.get(`Customers/${customerId}`);
};

export const getCustomerMembers = (customerId = "") => {
  return axiosInstance.get(`Users/?customerId=${customerId}`);
};
